export enum NotificationType {
  ParticipantJoined = 'participantJoined',
  HandRaised = 'handRaised',
  ParticipantMuted = 'participantMuted',
  MessageReceived = 'messageReceived',
  LowerHand = 'lowerHand',
  ReactionReceived = 'reactionReceived',
  ParticipantWaiting = 'participantWaiting',
  TranscriptionStarted = 'transcriptionStarted',
  TranscriptionStopped = 'transcriptionStopped',
  TranscriptionLimitReached = 'transcriptionLimitReached',
  ScreenRecordingStarted = 'screenRecordingStarted',
  ScreenRecordingStopped = 'screenRecordingStopped',
  ScreenRecordingLimitReached = 'screenRecordingLimitReached',
  RecordingSaving = 'recordingSaving',
  PermissionsRemoved = 'permissionsRemoved',
}
